import { cn } from "@/utils/cn";

type SubmitButtonProps = {
  disabled?: boolean;
  isSubmitting?: boolean;
  loadingText?: string;
  children: React.ReactNode;
  className?: string;
};

export function SubmitButton({
  disabled = false,
  isSubmitting = false,
  loadingText = "Saving…",
  children,
  className,
}: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled || isSubmitting}
      className={cn(
        !className &&
          "inline-flex min-h-[44px] min-w-[120px] items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90 disabled:opacity-50",
        className
      )}
    >
      {isSubmitting ? (
        <>
          <span
            className={cn(
              "mr-2 inline-block h-4 w-4 rounded-full border-2 border-current border-t-transparent animate-spin",
              className && "border-white"
            )}
            role="status"
            aria-hidden="true"
          />
          <span>{loadingText}</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
